import { InvoiceDetailsForm } from "@/app/Invoices/Forms/InvoiceDetailsForm";
import { useFormState } from "@/lib/Components/Form/Hooks/useFormState";
import { CreateInvoiceInput } from "@/gql/graphql";
import { InvoiceLineItemsForm } from "../../Forms/InvoiceLineItemsForm";
import { IllustrationsDocuments } from "@/assets/Illustrations";
import { EmptyState } from "@/lib/Components/EmptyState/EmptyState";

export function InvoiceCreateForm() {
  const { values } = useFormState<CreateInvoiceInput>();

  return (
    <>
      <InvoiceDetailsForm />
      {values.currency && values.payee.connect ? (
        <InvoiceLineItemsForm
          currency={values.currency}
          payeeId={values.payee.connect}
        />
      ) : (
        <EmptyState
          className="col-span-full"
          Icon={IllustrationsDocuments}
          header="Add line items"
          subheader="Select a payee and currency you wish to add line items for"
        />
      )}
    </>
  );
}
